import React, { useCallback, useEffect, useMemo } from "react";
import { SystemIndexRanges } from "@graylog/server-api";
import HideOnCloud from "util/conditional/HideOnCloud";
import { defaultOnError } from "util/conditional/onError";
import NumberUtils from "util/NumberUtils";
import { Col, Row, Button } from "components/bootstrap";
import { Spinner } from "components/common";
import IndexRangeSummary from "components/indices/IndexRangeSummary";
import ShardMeter from "components/indices/ShardMeter";
import ShardRoutingOverview from "components/indices/ShardRoutingOverview";
import { IndicesActions } from "stores/indices/IndicesStore";
const IndexDetails = ({ index, indexName, indexRange = void 0, indexSetId = void 0, isDeflector }) => {
  useEffect(() => {
    IndicesActions.subscribe(indexName);
    return () => {
      IndicesActions.unsubscribe(indexName);
    };
  }, [indexName]);
  const _onRecalculateIndex = useCallback(() => {
    if (window.confirm(`Really recalculate the index ranges for index ${indexName}?`)) {
      defaultOnError(
        SystemIndexRanges.rebuildIndex(indexName),
        `Could not create a job to start index ranges recalculation for ${indexName}`,
        `Error starting index ranges recalculation for ${indexName}`
      ).then(() => {
        if (indexSetId) {
          IndicesActions.list(indexSetId);
        }
      });
    }
  }, [indexName, indexSetId]);
  const _onDeleteIndex = useCallback(() => {
    if (window.confirm(`Really delete index ${indexName}?`)) {
      IndicesActions.delete(indexName).then(() => {
        if (indexSetId) {
          IndicesActions.list(indexSetId);
        }
      });
    }
  }, [indexName, indexSetId]);
  const actionButtons = useMemo(() => {
    if (isDeflector) {
      return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", disabled: true }, "Active write index cannot be deleted"));
    }
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "warning", bsSize: "xs", onClick: _onRecalculateIndex }, "Recalculate index ranges"), " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xs", onClick: _onDeleteIndex }, "Delete index"));
  }, [isDeflector, _onDeleteIndex, _onRecalculateIndex]);
  if (!index || !index.all_shards) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", { className: "index-info" }, /* @__PURE__ */ React.createElement(IndexRangeSummary, { indexRange }), " ", /* @__PURE__ */ React.createElement(HideOnCloud, null, NumberUtils.formatNumber(index.all_shards.segments), " segments,", " ", NumberUtils.formatNumber(index.all_shards.open_search_contexts), " open search contexts,", " ", NumberUtils.formatNumber(index.all_shards.documents.deleted), " deleted messages", /* @__PURE__ */ React.createElement(Row, { style: { marginBottom: "10" } }, /* @__PURE__ */ React.createElement(Col, { md: 4, className: "shard-meters" }, /* @__PURE__ */ React.createElement(ShardMeter, { title: "Primary shard operations", shardMeter: index.primary_shards })), /* @__PURE__ */ React.createElement(Col, { md: 4, className: "shard-meters" }, /* @__PURE__ */ React.createElement(ShardMeter, { title: "Total shard operations", shardMeter: index.all_shards }))), /* @__PURE__ */ React.createElement(ShardRoutingOverview, { routing: index.routing, indexName })), /* @__PURE__ */ React.createElement("hr", { style: { marginBottom: "5", marginTop: "10" } }), actionButtons);
};
export default IndexDetails;
